import React from "react"

export const CloseIcon = (props) => {
    return (
        <React.Fragment>
            <svg onClick={props.onClick} width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M1.02183 1.02195C1.33675 0.707038 1.84732 0.707038 2.16224 1.02195L10.7637 9.62346C11.0787 9.93837 11.0787 10.449 10.7637 10.7639C10.4488 11.0788 9.93825 11.0788 9.62333 10.7639L1.02183 2.16236C0.706916 1.84745 0.706916 1.33687 1.02183 1.02195Z" fill="#000000" />
                <path fillRule="evenodd" clipRule="evenodd" d="M10.7637 1.02195C11.0787 1.33687 11.0787 1.84745 10.7637 2.16236L2.16224 10.7639C1.84732 11.0788 1.33675 11.0788 1.02183 10.7639C0.706916 10.449 0.706916 9.93837 1.02183 9.62346L9.62333 1.02195C9.93825 0.707038 10.4488 0.707038 10.7637 1.02195Z" fill="#000000" />
            </svg>
        </React.Fragment>
    )
}